'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdHeadset = function MdHeadset(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 1.6c8.3 0 15 6.8 15 15v11.8c0 2.7-2.3 5-5 5h-5v-13.4h6.6v-3.4c0-6.4-5.1-11.6-11.6-11.6s-11.6 5.2-11.6 11.6v3.4h6.6v13.4h-5c-2.7 0-5-2.3-5-5v-11.8c0-8.2 6.7-15 15-15z' })
        )
    );
};

exports.default = MdHeadset;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/headset.js
// module id = 2412
// module chunks = 0